import { Controller } from "@hotwired/stimulus"

// Shows the year of the delivery date ("dd.mm.yyyy") as the invoice number
// prefix.
export default class extends Controller {
  static targets = ["date", "year"]

  connect() {
    this.update()
  }

  update() {
    const value = this.dateTarget.value
    if (value && value.length >= 4) {
      this.yearTarget.textContent = value.slice(-4)
    }
  }
}
